// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t8h0DOqWOVuwamiX9Ob3 {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 8px 8px;
}
@media (orientation: portrait) {
  .t8h0DOqWOVuwamiX9Ob3 {
    padding: 0 0 8px;
  }
}
.LTrQaQFBjLoTK_WoSrEo {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
.IuDtjxnJ9sl6HjX8clDf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 32px;
  text-align: center;
}
.BdLXFVGJk4vnCaq_qZdD {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #fff);
  margin-bottom: 8px;
}
._iVSqin4d97o5S7DIMvo {
  font-size: 14px;
  color: var(--text-secondary, rgba(255, 255, 255, 0.7));
}
@media (min-width: 1025px) {
  .t8h0DOqWOVuwamiX9Ob3 {
    padding-bottom: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/tabs/GamesTab/GamesTab.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,sDAAsD;AACxD;AACA;EACE;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".gamesTabContainer {\n  width: 100%;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px 8px;\n}\n@media (orientation: portrait) {\n  .gamesTabContainer {\n    padding: 0 0 8px;\n  }\n}\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  padding: 32px;\n  text-align: center;\n}\n.emptyTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary, #fff);\n  margin-bottom: 8px;\n}\n.emptyDescription {\n  font-size: 14px;\n  color: var(--text-secondary, rgba(255, 255, 255, 0.7));\n}\n@media (min-width: 1025px) {\n  .gamesTabContainer {\n    padding-bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gamesTabContainer": `t8h0DOqWOVuwamiX9Ob3`,
	"loadingContainer": `LTrQaQFBjLoTK_WoSrEo`,
	"emptyState": `IuDtjxnJ9sl6HjX8clDf`,
	"emptyTitle": `BdLXFVGJk4vnCaq_qZdD`,
	"emptyDescription": `_iVSqin4d97o5S7DIMvo`
};
export default ___CSS_LOADER_EXPORT___;
